export const FEATURE_NAME = '@zerops/zui/app-version-item';
